import React from 'react';

export const GameName = () => {
  return <h1 className='logo'>Wordle </h1>;
};
